import React from "react";
import SiteLayout from "./SiteLayout";
import { Outlet } from "react-router-dom";

const UnprotectedSiteLayout = () => (<SiteLayout><Outlet/></SiteLayout>);

export default UnprotectedSiteLayout;
